"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Partner = require("../../contexts/Partner");
var _confirmEmailMock = _interopRequireDefault(require("./confirmEmailMock"));
var _priceWatchMock = require("../PriceWatch/priceWatchMock");
var _Layout = _interopRequireDefault(require("../../components/Layout"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _Webmail = _interopRequireDefault(require("../../components/Webmail"));
var _ConfirmEmail = _interopRequireDefault(require("../../components/ConfirmEmail"));
var _Footer = _interopRequireDefault(require("../../components/Footer"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // mock из писем pricewatch, чтобы не дублировать шапку и футер
var layout = _confirmEmailMock["default"].layout,
  confirmEmail = _confirmEmailMock["default"].confirm_email,
  webmail = _confirmEmailMock["default"].webmail;
var organization = _priceWatchMock.mock.organization,
  unsubscribe = _priceWatchMock.mock.unsubscribe;
var footer = _objectSpread(_objectSpread({}, organization), unsubscribe);
var ConfirmEmail = function ConfirmEmail(_ref) {
  var partner = _ref.partner;
  return /*#__PURE__*/_react["default"].createElement(_Partner.PartnerContextProvider, {
    value: partner
  }, /*#__PURE__*/_react["default"].createElement(_Layout["default"], layout, /*#__PURE__*/_react["default"].createElement(_Webmail["default"], webmail), /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    fullWidth: true,
    bgColor: "#fff"
  }), /*#__PURE__*/_react["default"].createElement(_ConfirmEmail["default"], confirmEmail), /*#__PURE__*/_react["default"].createElement(_Footer["default"], footer)));
};
ConfirmEmail.defaultProps = {
  partner: null
};
ConfirmEmail.propTypes = {
  partner: _propTypes["default"].shape({
    isWl: _propTypes["default"].bool,
    name: _propTypes["default"].string,
    logo: _propTypes["default"].string,
    link: _propTypes["default"].string
  })
};
var _default = exports["default"] = ConfirmEmail;